import React, { useState } from "react"
import { FaSave } from "react-icons/fa"
import { Button, Modal, ModalBody, ModalHeader, Table } from "reactstrap"
import Swal from "sweetalert2"
import { FetchPostData, FetchPutData } from "utils/Common_api_functions"

const TrainingPlanModal = ({ isOpen, toggle, user , fetchData }) => {
  const [loading, setLoading] = useState(false)
  const [selectedDates, setSelectedDates] = useState({})

  const handleDateChange = (planId, date) => {
    setSelectedDates(prev => ({
      ...prev,
      [planId]: date,
    }))
  }

  const handleSubmit = async planId => {
    const startDate = selectedDates[planId]

    if (!startDate) {
      Swal.fire("Please select start date", "", "warning")
      return
    }

    const APIdata = await FetchPutData(
      setLoading,
      "user/insert/training/manually",
      user?._id,
      {
        training_start_date: startDate,
        training_plan_id: planId,
      }
    )

    if (APIdata?.data?.success) {
      Swal.fire({
        title: "Plan Date Added Successfully",
        text: APIdata?.data?.message,
        icon: "success",
      })
      toggle()
      fetchData()
    } else {
      Swal.fire({
        title: "Something Went Wrong",
        text: APIdata?.response?.data?.message,
        icon: "error",
      })
    }
  }

  return (
    <Modal isOpen={isOpen} size="xl" centered>
      <ModalHeader toggle={toggle}>
        Select Start Date for Remaining Training Plans
      </ModalHeader>

      <ModalBody>
        <Table>
          <thead>
            <tr>
              <th>#</th>
              <th>Training Plan Name</th>
              <th>Start Date</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {user?.trainingPlans
              ?.filter(item => item.isInserted === false)
              ?.map((item, index) => {
                const planId = item?.trainingPlan?._id

                return (
                  <tr key={planId}>
                    <td>{index + 1}</td>
                    <td>{item?.trainingPlan?.planName}</td>
                    <td>
                      <input
                        type="date"
                        className="form-control"
                        value={selectedDates[planId] || ""}
                        onChange={e => handleDateChange(planId, e.target.value)}
                      />
                    </td>
                    <td>
                      <Button
                        color="primary"
                        onClick={() => handleSubmit(planId)}
                        disabled={loading}
                      >
                        <FaSave />
                      </Button>
                    </td>
                  </tr>
                )
              })}
          </tbody>
        </Table>
      </ModalBody>
    </Modal>
  )
}

export default TrainingPlanModal
